// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ltjL","question":"styles_question__3oZTo","inputVisibleButton":"styles_inputVisibleButton__1M4xS","note":"styles_note__2OBQD"};